import { dew as _baseDew } from "../../errors/base.js";
import { dew as _encodingDew } from "../../errors/encoding.js";
import { dew as _cursorDew } from "../cursor.js";
import { dew as _toBytesDew } from "./toBytes.js";
import { dew as _toHexDew } from "./toHex.js";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.rlpToHex = exports.rlpToBytes = exports.fromRlp = void 0;
  const base_js_1 = _baseDew();
  const encoding_js_1 = _encodingDew();
  const cursor_js_1 = _cursorDew();
  const toBytes_js_1 = _toBytesDew();
  const toHex_js_1 = _toHexDew();
  function fromRlp(value, to = "hex") {
    const bytes = (() => {
      if (typeof value === "string") {
        if (value.length > 3 && value.length % 2 !== 0) throw new encoding_js_1.InvalidHexValueError(value);
        return (0, toBytes_js_1.hexToBytes)(value);
      }
      return value;
    })();
    const cursor = (0, cursor_js_1.createCursor)(bytes);
    const result = fromRlpCursor(cursor, to);
    return result;
  }
  exports.fromRlp = fromRlp;
  function rlpToBytes(bytes, to = "bytes") {
    return fromRlp(bytes, to);
  }
  exports.rlpToBytes = rlpToBytes;
  function rlpToHex(hex, to = "hex") {
    return fromRlp(hex, to);
  }
  exports.rlpToHex = rlpToHex;
  function fromRlpCursor(cursor, to = "hex") {
    if (cursor.bytes.length === 0) return to === "hex" ? (0, toHex_js_1.bytesToHex)(cursor.bytes) : cursor.bytes;
    const prefix = cursor.readByte();
    if (prefix < 128) cursor.decrementPosition(1);
    if (prefix < 192) {
      const length = readLength(cursor, prefix, 128);
      const bytes = cursor.readBytes(length);
      return to === "hex" ? (0, toHex_js_1.bytesToHex)(bytes) : bytes;
    }
    const length = readLength(cursor, prefix, 192);
    return readList(cursor, length, to);
  }
  function readLength(cursor, prefix, offset) {
    if (offset === 128 && prefix < 128) return 1;
    if (prefix <= offset + 55) return prefix - offset;
    if (prefix === offset + 55 + 1) return cursor.readUint8();
    if (prefix === offset + 55 + 2) return cursor.readUint16();
    if (prefix === offset + 55 + 3) return cursor.readUint24();
    if (prefix === offset + 55 + 4) return cursor.readUint32();
    throw new base_js_1.BaseError("Invalid RLP prefix");
  }
  function readList(cursor, length, to) {
    const position = cursor.position;
    const value = [];
    while (cursor.position - position < length) value.push(fromRlpCursor(cursor, to));
    return value;
  }
  //# sourceMappingURL=fromRlp.js.map
  return exports;
}